import React, { useEffect, useCallback, useState, useMemo } from 'react';
import { useDispatch } from 'react-redux';
import mixpanel, { trackedEvents } from 'utils/mixpanel';
import { useIsSignedIn } from 'entity/user/userHooks';
import { useFeedCurrentPage } from 'entity/feed/feedHooks';
import {
  useSelectFollowedGroupList,
  usePromptGroupModal,
} from 'entity/group/groupHooks';
import { openLoginModal } from 'dispatcher/modalDispatcher';
import { getFeedsRequest } from 'entity/feed/feedRedux';
import { TrendingContentContext } from '../../context/TrendingContentContext';
import FeedList from '../HomeContent/FeedList';
import MockDiscussionCard from '../HomeContent/MockDiscussionCard';

const TrendingContent = () => {
  const dispatch = useDispatch();

  const [followedIds, setFollowedIds] = useState([]);

  const currentPage = useFeedCurrentPage();
  const followedGroups = useSelectFollowedGroupList();
  const isSignedIn = useIsSignedIn();

  useEffect(() => {
    dispatch(getFeedsRequest({ feedFilter: 'trending', page: 1 }));
  }, [dispatch]);

  useEffect(() => {
    const followedGroupIds = followedGroups.map(group => group.id);
    if (followedIds.length === 0 && followedGroupIds.length > 0) {
      setFollowedIds(followedGroupIds);
    }
  }, [followedGroups, followedIds]);

  // load more feeds
  const handleLoadMoreFeed = useCallback(() => {
    mixpanel.track(trackedEvents.LoadMorePostClicked, {});

    if (!isSignedIn) {
      dispatch(openLoginModal());
      return;
    }

    dispatch(
      getFeedsRequest({ feedFilter: 'trending', page: currentPage + 1 }),
    );
  }, [dispatch, currentPage, isSignedIn]);

  usePromptGroupModal();

  const contextValue = useMemo(() => {
    return { followedGroupIds: followedIds };
  }, [followedIds]);

  return (
    <TrendingContentContext.Provider value={contextValue}>
      <div className="flex flex-col w-full gap-2">
        <MockDiscussionCard />
        <FeedList handleLoadMoreFeed={handleLoadMoreFeed} />
      </div>
    </TrendingContentContext.Provider>
  );
};

export default TrendingContent;
